'use client';

import React, { useEffect, useMemo } from 'react';
import componentRegistry from './ComponentRegistry';
import { useSearchParams, usePathname } from 'next/navigation';
import useCustomSWR from '@/hook/useCustomSWR';
import BASE_URL from '../constants';
import getToken from '@/hook/getToken';

const trackUserHistory = async (brandId) => {
  const token = getToken();
  if (!brandId || !token) return;

  try {
    await fetch(`${BASE_URL}/v1/recent-activity/add-recent-view-brand`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ brandId }),
    });
  } catch (error) {
    console.error('Failed to track user history:', error);
  }
};

const BrandPreview = ({ slug }) => {
  const { data, error, isLoading } = useCustomSWR(
    slug ? `/v1/brand-page-cms/content-list-slug?slug=${slug}` : null,
    true
  );

  const brandId = data?.data?.brand_id;
  const components = data?.data?.data;

  // Track user history once brandId is available
  useEffect(() => {
    if (!brandId) return;

    const timeout = setTimeout(() => {
      trackUserHistory(brandId);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [brandId]);

  const renderedComponents = useMemo(() => {
    return components?.map((item, index) => {
      const Component = componentRegistry[item.component];
      if (!Component) return null;

      return <Component key={`${item.component}-${index}`} data={item.data} />;
    });
  }, [components]);

  if (isLoading) {
    return <div className="p-4 text-center">Loading...</div>;
  }

  if (error) {
    return <div className="p-4 text-center text-red-500">Failed to load content.</div>;
  }

  return (
    <main>
      <div className='-mt-5 flex w-full flex-col gap-2 overflow-hidden md:gap-5'>
        {renderedComponents}
      </div>
    </main>
  );
};

export default BrandPreview;
